import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_OPTIONS_SEARCH_QUERY', function (query, suppressFailedSearchDatapoints) {
    getStore().query = query;
    getStore().suppressFailedSearchDatapoints = suppressFailedSearchDatapoints;
});
//# sourceMappingURL=setQuery.js.map